module.exports = __webpack_public_path__ + "img/18.dfcf0ae9.png";